import { ApiShopperLandingPage } from '@storefronts/common-types'
import Script from 'next/script'
import './pixelRuntime'

export const Elevar: React.FC<{ landingPage: ApiShopperLandingPage }> = ({
    landingPage,
}) => {
    const configId = landingPage.integrations.elevarConfigId
    if (!configId) return null

    return (
        <Script id="elevar-script" type="module" strategy="afterInteractive">
            {`
                try {
                  const response = await fetch("https://shopify-gtm-suite.getelevar.com/configs/" + ${JSON.stringify(configId)} + "/config.json");
                  const config = await response.json();
                  const scriptUrl = config.script_src_custom_pages;

                  if (scriptUrl) {
                    const { handler } = await import(scriptUrl);
                    await handler(config);
                  }
                } catch (error) {
                  console.error("Elevar Error:", error);
                } finally {
                  window.__sfMarkVendorReady && window.__sfMarkVendorReady("elevar");
                }
            `}
        </Script>
    )
}
